import React from 'react';
import { useNavigate } from 'react-router-dom';
import TopicCard from '../components/TopicCard';
import { useTheme } from '../contexts/ThemeContext';
import { demoVideos } from '../data/demoData';
import { CATEGORIES } from '../types';

export default function VideosPage() {
  const navigate = useNavigate();
  const { theme } = useTheme();

  const handleLike = async (videoId: string) => {
    // In a real app, this would call an API
    console.log('Liked video:', videoId);
  };

  const handleShare = async (videoId: string) => {
    const video = demoVideos.find(v => v.id === videoId);
    if (video) {
      try {
        await navigator.share({
          title: video.title,
          text: video.description,
          url: `${window.location.origin}/video/${video.id}`,
        });
      } catch (err) {
        navigator.clipboard.writeText(`${window.location.origin}/video/${video.id}`);
        alert('Link copied to clipboard!');
      }
    }
  };

  return (
    <div className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className={`text-3xl font-bold ${
            theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
          }`}>
            Videos
          </h1>
          <button
            onClick={() => navigate('/upload')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Upload Video
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {demoVideos.map(video => (
            <TopicCard
              key={video.id}
              topic={{
                ...video,
                category: CATEGORIES.find(cat => cat.name === video.category) || CATEGORIES[0]
              }}
              onLike={() => handleLike(video.id)}
              onShare={() => handleShare(video.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}